import { Tooltip } from '@mui/material';

//Note: styled to match ILIAS drv-bund system style

const StyledTooltip = ({ text, color, children, ...props }) => {
  return (
	  <Tooltip
		  title={text}
		  placement='right-end'
		  componentsProps={{
			  tooltip: {
				  sx: {
					  color: color,
					  bgcolor: '#FFFFFF',
					  borderRadius: '4px',
					  boxShadow: `1px 1px 3px 1px ${color}`,
				  }
			  }
		  }}
		  slotProps={{
			  popper: {
				  modifiers: [
					  {
						  name: 'offset',
						  options: {
							  offset: [15, -30],
						  },
					  },
				  ],
			  },
		  }}
		  {...props}
	  >
		  {children}
	  </Tooltip>
  );
};

export { StyledTooltip };